// extracted by mini-css-extract-plugin
module.exports = {"CenterSpinner":"Spinner_CenterSpinner__T-aaE","Spinner":"Spinner_Spinner__1XnIF","load3":"Spinner_load3__BqqwG"};